import { render, staticRenderFns } from "./BatchRiOutwardsRelease.vue?vue&type=template&id=1b7cd98d&"
import script from "./BatchRiOutwardsRelease.vue?vue&type=script&lang=js&"
export * from "./BatchRiOutwardsRelease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports